import { component } from "picoapp";
import { type Context, type SelectedVariant } from "../../state";
import { translateShippingNote } from "../../utilities/translation";

export const variantShippingNote = component<Context>((node, context) => {
  const { productHandle } =
    node.closest<HTMLElement>("[data-product-handle]")?.dataset ?? {};
  const formElement = document.querySelector<HTMLFormElement>(
    `form[id="product-form"]`
  );
  const currentOptionCategory = node.closest<HTMLElement>(
    "[data-option-category]"
  )?.dataset.optionCategory;

  if (!productHandle || !formElement) {
    return;
  }

  const isShopifyBundle = formElement.dataset.shopifyBundle === "true";

  // Translate initial shipping note on component initialization
  const textElement = node.querySelector("[data-tbsp-component='text']");
  if (
    textElement &&
    textElement.textContent &&
    textElement.textContent.trim() !== ""
  ) {
    const initialText = textElement.textContent.trim();
    const translatedInitialText = translateShippingNote(initialText);
    textElement.textContent = translatedInitialText ?? "";
  }

  const getBundleProductVariantShippingNote = (
    selectedVariant: SelectedVariant,
    productOptionIndex: number
  ) => {
    const bundleProductName = selectedVariant.selectedOptions[
      productOptionIndex
    ].name.replace(/ *\([^)]*\) */g, "");
    return document.querySelector<HTMLOptionElement>(
      `select[name="shopify-bundle-metadata"] optgroup[label="${bundleProductName}"] option[value="${selectedVariant.selectedOptions[productOptionIndex].value}"]`
    )?.dataset?.variantShippingNote;
  };

  context.on("tbsp:variant-selected", ({ selectedVariant }) => {
    if (selectedVariant.handle !== productHandle) {
      return;
    }

    const textElement = node.querySelector("[data-tbsp-component='text']");
    if (textElement) {
      textElement.textContent = "";
    }

    if (
      currentOptionCategory &&
      currentOptionCategory !== selectedVariant.optionCategory
    ) {
      return;
    }

    let newShippingNote = selectedVariant.shippingNote;

    if (isShopifyBundle) {
      const productOptionIndex = Number(
        node.closest<HTMLFieldSetElement>("fieldset")?.dataset
          ?.productOptionIndex
      );

      newShippingNote =
        getBundleProductVariantShippingNote(
          selectedVariant,
          productOptionIndex
        ) ?? null;
    }

    const translatedNote = translateShippingNote(newShippingNote);
    const noteTextElement = node.querySelector("[data-tbsp-component='text']");
    if (noteTextElement) {
      noteTextElement.textContent = translatedNote ?? "";
    }
  });
});
